import React from "react"
import styled from "styled-components"
import BlogIcon from "@zendeskgarden/svg-icons/src/16/file-document-stroke.svg"
import ForumIcon from "@zendeskgarden/svg-icons/src/16/speech-bubble-plain-stroke.svg"
import SlackIcon from "@zendeskgarden/svg-icons/src/16/slack-stroke.svg"

const Container = styled.footer`
  width: 100%;
  margin-top: ${props => props.theme.space.xxl};
  padding: ${props => props.theme.space.xxl} ${props => props.theme.space.xs}
    ${props => props.theme.space.xxl} ${props => props.theme.space.xs};
  text-align: center;
  background-color: ${props => props.theme.colors.background};
  border-top: ${props =>
    `${props.theme.borders.sm} ${props.theme.colors.footer.border}`};

  a {
    color: ${props => props.theme.colors.footer.link};
  }
`

const CompanyName = styled.span`
  margin-right: ${props => props.theme.space.xs};
  color: ${props => props.theme.colors.footer.companyName};
  font-weight: ${props => props.theme.fontWeights.semibold};
`

const Address = styled.div`
  margin-top: ${props => props.theme.space.xxl};
  margin-bottom: ${props => props.theme.space.sm};
  color: ${props => props.theme.colors.footer.address};
  font-size: ${props => props.theme.fontSizes.sm};
`

const Heading = styled.div`
  color: ${props => props.theme.colors.footer.heading};
  font-weight: ${props => props.theme.fontWeights.semibold};
  font-size: ${props => props.theme.fontSizes.md};
`

const LinkWithIcon = styled.a`
  display: inline-flex;
  align-items: center;
  margin: 0 ${props => props.theme.space.xs};
  padding-top: ${props => props.theme.space.md};
  font-size: ${props => props.theme.fontSizes.md};

  svg {
    margin-right: ${props => props.theme.space.xs};
  }
`

const LegalLinks = styled.div`
  font-size: ${props => props.theme.fontSizes.sm};

  a {
    display: inline-block;
    padding: 0 ${props => props.theme.space.sm};
    border-right: ${props => props.theme.borders.sm}
      ${props => props.theme.colors.footer.address};

    &:last-child {
      border-right: none;
    }
  }
`

const Footer = () => (
  <Container>
    <Heading>Join our developer community</Heading>

    <LinkWithIcon
      href="https://support.zendesk.com/hc/en-us/community/topics"
      target="_blank"
      rel="noreferrer noopener"
    >
      <ForumIcon />
      Forum
    </LinkWithIcon>

    <LinkWithIcon
      href="https://developerblog.zendesk.com"
      target="_blank"
      rel="noreferrer noopener"
    >
      <BlogIcon />
      Blog
    </LinkWithIcon>

    <LinkWithIcon
      href="https://docs.google.com/forms/d/e/1FAIpQLScm_rDLWwzWnq6PpYWFOR_PwMaSBcaFft-1pYornQtBGAaiJA/viewform"
      target="_blank"
      rel="noreferrer noopener"
    >
      <SlackIcon />
      Slack
    </LinkWithIcon>

    <Address>
      <CompanyName>Zendesk</CompanyName>
      181 Fremont Street, 17th Floor, San Francisco, California 94105
    </Address>

    <LegalLinks>
      <a
        href="https://www.zendesk.com/company/agreements-and-terms/privacy-policy/"
        target="_blank"
        rel="noreferrer noopener"
      >
        Privacy Policy
      </a>
      <a
        href="https://www.zendesk.com/company/agreements-and-terms/master-subscription-agreement/"
        target="_blank"
        rel="noreferrer noopener"
      >
        Terms & Conditions
      </a>
      <a
        href="https://status.zendesk.com"
        target="_blank"
        rel="noreferrer noopener"
      >
        System Status
      </a>
      <a
        href="#onetrust-show-cookie-settings"
        className="ot-sdk-show-settings"
        id="onetrust-show-cookie-settings"
      >
        Cookie Settings
      </a>
    </LegalLinks>
  </Container>
)

export default Footer
